import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  mapViewerOuterContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  mapViewerContainer: {
    flex: 1,
    height: '100%',
    position: 'relative',
    backgroundColor: '#fff',
  },
  compassContainer: {
    width: 80,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    boxShadow: '0 0 8px rgba(0,0,0,0.04)',
  },
  compassIcon: {
    width: 48,
    marginBottom: theme.spacing(2),
  },
}));
